export const DS_LOCALE =  {
    "en": {
        "zoom-out": "Zoom Out",
        "zoom-in": "Zoom In",
        "invert": "Invert",
        "bigger-cursor": "Bigger Cursor",
        "brightness": "Brightness",
        "contrast": "Contrast",
        "grayscale": "Grayscale",
        "reset": "Undo Changes"
    },
    "tr": {
        "zoom-out": "Uzaklaş",
        "zoom-in": "Yaklaş",
        "invert": "Ters Çevir",
        "bigger-cursor": "Büyük İmleç",
        "brightness": "Parlaklık",
        "contrast": "Zıtlık",
        "grayscale": "Gri Ton",
        "reset": "Geri Al"
    },
};

export const DS_TEMPLATE = `<div class="ds-accessibility-cursor-workaround"></div>
<div class="ds-accessibility ds-accessibility-collapsed">
    <div class="ds-accessibility-container">

        <div class="ds-accessibility-expand-button">
            <div class="ds-accessibility-icon ds-accessibility-icon--expand"></div>
        </div>

        <div class="ds-accessibility-menu">
            <div class="ds-accessibility-close-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--close"></div>
            </div>

            <div class="ds-accessibility-menu-button ds-accessibility-zoom-out-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--zoom-out"></div>
                <span data-lang="zoom-out">Zoom Out</span>
            </div>

            <div class="ds-accessibility-menu-button ds-accessibility-zoom-in-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--zoom-in"></div>
                <span data-lang="zoom-in">Zoom In</span>
            </div>

            <div class="ds-accessibility-menu-button ds-accessibility-invert-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--invert"></div>
                <span data-lang="invert">Invert</span>
            </div>

            <div class="ds-accessibility-menu-button ds-accessibility-cursor-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--cursor"></div>
                <span data-lang="bigger-cursor">Bigger Cursor</span>
            </div>

            <div class="ds-accessibility-menu-button ds-accessibility-brightness-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--brightness"></div>
                <span data-lang="brightness">Brightness</span>
            </div>

            <div class="ds-accessibility-menu-button ds-accessibility-contrast-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--contrast"></div>
                <span data-lang="contrast">Contrast</span>
            </div>

            <div class="ds-accessibility-menu-button ds-accessibility-monochrome-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--monochrome"></div>
                <span data-lang="grayscale">Monochrome</span>
            </div>

            <div class="ds-accessibility-menu-button ds-accessibility-reset-button">
                <div class="ds-accessibility-icon ds-accessibility-icon--revert"></div>
                <span data-lang="reset">Revert</span>
            </div>
        </div>
    </div>
</div>`;

export const DS_LOCAL_STORAGE_OPTIONS_KEY = 'ds-accessibility-config';

export const DS_UNITS = ['px', 'cm', 'em', 'ex', 'in', 'mm', 'pc', 'pt', 'vh', 'vw', 'vmin'];
